import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { useDispatch } from 'react-redux'
import { signOut } from 'reducks/auth/operations'

const LogoutMenuCard: FC = () => {
  const dispatch = useDispatch()

  return (
    <a className={styles.menu__logout} role={'button'} onClick={() => dispatch(signOut())} data-cy={'logout-menu-card'}>
      <h2>ログアウト</h2>
    </a>
  )
}

export default LogoutMenuCard
